import { render, staticRenderFns } from "./_patentdub.vue?vue&type=template&id=17b64606"
import script from "./_patentdub.vue?vue&type=script&lang=js"
export * from "./_patentdub.vue?vue&type=script&lang=js"
import style0 from "./_patentdub.vue?vue&type=style&index=0&id=17b64606&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports